import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { AutomationModule } from './automation/automation.module';
import { EnvironmentActivitiesModule } from './environment-activities/environment-activities.module';
import { EnvironmentDatabasesModule } from './environment-databases/environment-databases.module';
import { EnvironmentMenuModule } from './environment-menu/environment-menu.module';
import { SummaryEnvironmentModule } from './summary-environment/summary-environment.module';
import { DeployedPackagesModule } from '@app/authorized/environmentDetails/deployed-packages/deployed-packages.module';

@NgModule({
    imports: [
        SharedModule,

        AutomationModule,
        EnvironmentActivitiesModule,
        EnvironmentDatabasesModule,
        EnvironmentMenuModule,
        SummaryEnvironmentModule,
        DeployedPackagesModule
    ]
})
export class EnvironmentDetailsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-details.module.ts